<template>
  <div
    v-show="showElement"
    class="destination-list-card"
    @keypress.enter.prevent="destinationSelected(item)"
    @keypress.space.prevent="destinationSelected(item)"
  >
    <div class="destination-list-card-label">
      <label
        :for="item.value"
        tabindex="0"
      >
        <span
          class="destination-name"
          v-html="parsedPropertyName ? parsedPropertyName : item.label"
        />
      </label>
    </div>
    <span
      v-if="localValue"
      class="destination-list-card-icon icon-checkmark-circle"
    />
    <div class="destination-list-card-checkbox">
      <input
        :id="item.value"
        ref="checkbox"
        :key="JSON.stringify(item) + `checkbox`"
        type="checkbox"
        :value="item.value"
        :checked="!!localValue"
        :name="`interest-` + item.value"
        data-field-type="CheckBoxSet"
        @keypress.enter.prevent="destinationSelected(item)"
        @input="destinationSelected(item)"
      >
    </div>
  </div>
</template>

<script>
  import { highlightMatch } from '@utils/highlight-match'

  export default {
    name: 'DestinationListCard',
    props: {
      item: {
        type: Object
      },
      searchInput: {
        type: String,
        default: ''
      },
      queryChanged: {
        type: Number,
        default: -1
      },
      selectedItems: {
        type: Array,
        default: () => []
      },
      filteredItems: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    data: () => ({
      searchString: ''
    }),
    computed: {
      showElement() {
        return !!this.filteredItems.find(e => e.value === this.item.value);
      },
      localValue() {
        return this.selectedItems.find((el) => el.value === this.item.value)
      },
      parsedPropertyName: {
        get() {
          return highlightMatch(this.searchString, this.item.label, 'bold-highlighted')
        },
        set(newValue) {
          this.searchString = newValue
        }
      },
      parsedCountry: {
        get() {
          return highlightMatch(this.searchString, this.item.country, 'bold-highlighted')
        },
        set(newValue) {
          this.searchString = newValue
        }
      }
    },
    watch: {
      searchInput(val) {
        if (val) {
          this.searchString = val
        } else {
          this.searchString = ''
        }
      },
      async queryChanged() {
        this.searchString = this.searchInput
      }
    },
    methods: {
      destinationSelected(item) {
        this.$emit('destination-selected', item)
      }
    }
  }
</script>
